var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "time",
    {
      attrs: {
        datetime: _vm.date.toISOString(),
      },
    },
    [_vm._v(_vm._s(_vm.formatted))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }